// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcompanhamentoNutricionalAustraliaRouteImport } from './routes/acompanhamento-nutricional-australia'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AlimentacaoSaudavelHospitalityAustraliaRouteImport } from './routes/alimentacao-saudavel-hospitality-australia'
import { Route as AnamneseRouteImport } from './routes/anamnese'
import { Route as AnamneseRetornoRouteImport } from './routes/anamnese-retorno'
import { Route as AppRouteImport } from './routes/app'
import { Route as ComoEmagrecerMorandoNaAustraliaRouteImport } from './routes/como-emagrecer-morando-na-australia'
import { Route as ConsultaInicialGratuitaRouteImport } from './routes/consulta-inicial-gratuita'
import { Route as ConsultaNutricionalOnlineAustraliaRouteImport } from './routes/consulta-nutricional-online-australia'
import { Route as ConsultoriaRouteImport } from './routes/consultoria'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as DietaEstudantesBrasileirosAustraliaRouteImport } from './routes/dieta-estudantes-brasileiros-australia'
import { Route as FormsRouteImport } from './routes/forms'
import { Route as GuiaAlimentacaoBrasileirosAustraliaRouteImport } from './routes/guia-alimentacao-brasileiros-australia'
import { Route as KitVidaSaudavelRouteImport } from './routes/kit-vida-saudavel'
import { Route as LinksRouteImport } from './routes/links'
import { Route as MercadoAustralianoOQueComprarRouteImport } from './routes/mercado-australiano-o-que-comprar'
import { Route as NutricionistaBrasileiraBrisbaneRouteImport } from './routes/nutricionista-brasileira-brisbane'
import { Route as NutricionistaBrasileiraMelbourneRouteImport } from './routes/nutricionista-brasileira-melbourne'
import { Route as NutricionistaBrasileiraNaAustraliaRouteImport } from './routes/nutricionista-brasileira-na-australia'
import { Route as NutricionistaBrasileiraSydneyRouteImport } from './routes/nutricionista-brasileira-sydney'
import { Route as ObrigadoRouteImport } from './routes/obrigado'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as PortugueseSpeakingNutritionistBrisbaneRouteImport } from './routes/portuguese-speaking-nutritionist-brisbane'
import { Route as PromoDiaDasMulheresRouteImport } from './routes/promo-dia-das-mulheres'
import { Route as QuestionarioRouteImport } from './routes/questionario'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as RaioXRouteImport } from './routes/raio-x'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as VagaRouteImport } from './routes/vaga'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAutorizarRouteImport } from './routes/admin/autorizar'
import { Route as AdminAvisosRouteImport } from './routes/admin/avisos'
import { Route as AdminFinanceiroRouteImport } from './routes/admin/financeiro'
import { Route as AdminFunilRouteImport } from './routes/admin/funil'
import { Route as AdminMaisRouteImport } from './routes/admin/mais'
import { Route as AdminPlataformaRouteImport } from './routes/admin/plataforma'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAvisosRouteImport } from './routes/app/avisos'
import { Route as AppDesafiosRouteImport } from './routes/app/desafios'
import { Route as AppEvolucaoRouteImport } from './routes/app/evolucao'
import { Route as AppInstalarRouteImport } from './routes/app/instalar'
import { Route as AppMateriaisRouteImport } from './routes/app/materiais'
import { Route as AppPlanoRouteImport } from './routes/app/plano'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ClubeIndexRouteImport } from './routes/clube/index'
import { Route as ClubeBemVindaRouteImport } from './routes/clube/bem-vinda'
import { Route as DiagnosticoIndexRouteImport } from './routes/diagnostico/index'
import { Route as DiagnosticoResultadoRouteImport } from './routes/diagnostico/resultado'
import { Route as PlataformaIndexRouteImport } from './routes/plataforma/index'
import { Route as PlataformaAdminRouteImport } from './routes/plataforma/admin'
import { Route as PlataformaLoginRouteImport } from './routes/plataforma/login'
import { Route as PlataformaNoAccessRouteImport } from './routes/plataforma/no-access'
import { Route as AdminContratosIndexRouteImport } from './routes/admin/contratos/index'
import { Route as AdminContratosNovoRouteImport } from './routes/admin/contratos/novo'
import { Route as AdminDesafiosIndexRouteImport } from './routes/admin/desafios/index'
import { Route as AdminDesafiosIdRouteImport } from './routes/admin/desafios/$id'
import { Route as AdminFormulariosIndexRouteImport } from './routes/admin/formularios/index'
import { Route as AdminFormulariosTipoRouteImport } from './routes/admin/formularios/$tipo'
import { Route as AdminPacientesIndexRouteImport } from './routes/admin/pacientes/index'
import { Route as AdminPacientesIdRouteImport } from './routes/admin/pacientes/$id'
import { Route as AppFormularioIdRouteImport } from './routes/app/formulario/$id'
import { Route as AppPerfilIndexRouteImport } from './routes/app/perfil/index'
import { Route as AppPerfilPagamentosRouteImport } from './routes/app/perfil/pagamentos'
import { Route as AdminContratosIdIndexRouteImport } from './routes/admin/contratos/$id/index'
import { Route as AdminContratosIdEditarRouteImport } from './routes/admin/contratos/$id/editar'
import { Route as AdminFormulariosTipoIndexRouteImport } from './routes/admin/formularios/$tipo/index'
import { Route as AdminFormulariosTipoRespostaIdRouteImport } from './routes/admin/formularios/$tipo/$respostaId'
import { Route as AdminPacientesIdAppRouteImport } from './routes/admin/pacientes/$id_.app'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AcompanhamentoNutricionalAustraliaRoute = AcompanhamentoNutricionalAustraliaRouteImport.update({
            id: '/acompanhamento-nutricional-australia',path: '/acompanhamento-nutricional-australia',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AlimentacaoSaudavelHospitalityAustraliaRoute = AlimentacaoSaudavelHospitalityAustraliaRouteImport.update({
            id: '/alimentacao-saudavel-hospitality-australia',path: '/alimentacao-saudavel-hospitality-australia',getParentRoute: () => rootRouteImport
          })
const AnamneseRoute = AnamneseRouteImport.update({
            id: '/anamnese',path: '/anamnese',getParentRoute: () => rootRouteImport
          })
const AnamneseRetornoRoute = AnamneseRetornoRouteImport.update({
            id: '/anamnese-retorno',path: '/anamnese-retorno',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const ComoEmagrecerMorandoNaAustraliaRoute = ComoEmagrecerMorandoNaAustraliaRouteImport.update({
            id: '/como-emagrecer-morando-na-australia',path: '/como-emagrecer-morando-na-australia',getParentRoute: () => rootRouteImport
          })
const ConsultaInicialGratuitaRoute = ConsultaInicialGratuitaRouteImport.update({
            id: '/consulta-inicial-gratuita',path: '/consulta-inicial-gratuita',getParentRoute: () => rootRouteImport
          })
const ConsultaNutricionalOnlineAustraliaRoute = ConsultaNutricionalOnlineAustraliaRouteImport.update({
            id: '/consulta-nutricional-online-australia',path: '/consulta-nutricional-online-australia',getParentRoute: () => rootRouteImport
          })
const ConsultoriaRoute = ConsultoriaRouteImport.update({
            id: '/consultoria',path: '/consultoria',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const DietaEstudantesBrasileirosAustraliaRoute = DietaEstudantesBrasileirosAustraliaRouteImport.update({
            id: '/dieta-estudantes-brasileiros-australia',path: '/dieta-estudantes-brasileiros-australia',getParentRoute: () => rootRouteImport
          })
const FormsRoute = FormsRouteImport.update({
            id: '/forms',path: '/forms',getParentRoute: () => rootRouteImport
          })
const GuiaAlimentacaoBrasileirosAustraliaRoute = GuiaAlimentacaoBrasileirosAustraliaRouteImport.update({
            id: '/guia-alimentacao-brasileiros-australia',path: '/guia-alimentacao-brasileiros-australia',getParentRoute: () => rootRouteImport
          })
const KitVidaSaudavelRoute = KitVidaSaudavelRouteImport.update({
            id: '/kit-vida-saudavel',path: '/kit-vida-saudavel',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const MercadoAustralianoOQueComprarRoute = MercadoAustralianoOQueComprarRouteImport.update({
            id: '/mercado-australiano-o-que-comprar',path: '/mercado-australiano-o-que-comprar',getParentRoute: () => rootRouteImport
          })
const NutricionistaBrasileiraBrisbaneRoute = NutricionistaBrasileiraBrisbaneRouteImport.update({
            id: '/nutricionista-brasileira-brisbane',path: '/nutricionista-brasileira-brisbane',getParentRoute: () => rootRouteImport
          })
const NutricionistaBrasileiraMelbourneRoute = NutricionistaBrasileiraMelbourneRouteImport.update({
            id: '/nutricionista-brasileira-melbourne',path: '/nutricionista-brasileira-melbourne',getParentRoute: () => rootRouteImport
          })
const NutricionistaBrasileiraNaAustraliaRoute = NutricionistaBrasileiraNaAustraliaRouteImport.update({
            id: '/nutricionista-brasileira-na-australia',path: '/nutricionista-brasileira-na-australia',getParentRoute: () => rootRouteImport
          })
const NutricionistaBrasileiraSydneyRoute = NutricionistaBrasileiraSydneyRouteImport.update({
            id: '/nutricionista-brasileira-sydney',path: '/nutricionista-brasileira-sydney',getParentRoute: () => rootRouteImport
          })
const ObrigadoRoute = ObrigadoRouteImport.update({
            id: '/obrigado',path: '/obrigado',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const PortugueseSpeakingNutritionistBrisbaneRoute = PortugueseSpeakingNutritionistBrisbaneRouteImport.update({
            id: '/portuguese-speaking-nutritionist-brisbane',path: '/portuguese-speaking-nutritionist-brisbane',getParentRoute: () => rootRouteImport
          })
const PromoDiaDasMulheresRoute = PromoDiaDasMulheresRouteImport.update({
            id: '/promo-dia-das-mulheres',path: '/promo-dia-das-mulheres',getParentRoute: () => rootRouteImport
          })
const QuestionarioRoute = QuestionarioRouteImport.update({
            id: '/questionario',path: '/questionario',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const RaioXRoute = RaioXRouteImport.update({
            id: '/raio-x',path: '/raio-x',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const VagaRoute = VagaRouteImport.update({
            id: '/vaga',path: '/vaga',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAutorizarRoute = AdminAutorizarRouteImport.update({
            id: '/autorizar',path: '/autorizar',getParentRoute: () => AdminRoute
          })
const AdminAvisosRoute = AdminAvisosRouteImport.update({
            id: '/avisos',path: '/avisos',getParentRoute: () => AdminRoute
          })
const AdminFinanceiroRoute = AdminFinanceiroRouteImport.update({
            id: '/financeiro',path: '/financeiro',getParentRoute: () => AdminRoute
          })
const AdminFunilRoute = AdminFunilRouteImport.update({
            id: '/funil',path: '/funil',getParentRoute: () => AdminRoute
          })
const AdminMaisRoute = AdminMaisRouteImport.update({
            id: '/mais',path: '/mais',getParentRoute: () => AdminRoute
          })
const AdminPlataformaRoute = AdminPlataformaRouteImport.update({
            id: '/plataforma',path: '/plataforma',getParentRoute: () => AdminRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppAvisosRoute = AppAvisosRouteImport.update({
            id: '/avisos',path: '/avisos',getParentRoute: () => AppRoute
          })
const AppDesafiosRoute = AppDesafiosRouteImport.update({
            id: '/desafios',path: '/desafios',getParentRoute: () => AppRoute
          })
const AppEvolucaoRoute = AppEvolucaoRouteImport.update({
            id: '/evolucao',path: '/evolucao',getParentRoute: () => AppRoute
          })
const AppInstalarRoute = AppInstalarRouteImport.update({
            id: '/instalar',path: '/instalar',getParentRoute: () => AppRoute
          })
const AppMateriaisRoute = AppMateriaisRouteImport.update({
            id: '/materiais',path: '/materiais',getParentRoute: () => AppRoute
          })
const AppPlanoRoute = AppPlanoRouteImport.update({
            id: '/plano',path: '/plano',getParentRoute: () => AppRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ClubeIndexRoute = ClubeIndexRouteImport.update({
            id: '/clube/',path: '/clube/',getParentRoute: () => rootRouteImport
          })
const ClubeBemVindaRoute = ClubeBemVindaRouteImport.update({
            id: '/clube/bem-vinda',path: '/clube/bem-vinda',getParentRoute: () => rootRouteImport
          })
const DiagnosticoIndexRoute = DiagnosticoIndexRouteImport.update({
            id: '/diagnostico/',path: '/diagnostico/',getParentRoute: () => rootRouteImport
          })
const DiagnosticoResultadoRoute = DiagnosticoResultadoRouteImport.update({
            id: '/diagnostico/resultado',path: '/diagnostico/resultado',getParentRoute: () => rootRouteImport
          })
const PlataformaIndexRoute = PlataformaIndexRouteImport.update({
            id: '/plataforma/',path: '/plataforma/',getParentRoute: () => rootRouteImport
          })
const PlataformaAdminRoute = PlataformaAdminRouteImport.update({
            id: '/plataforma/admin',path: '/plataforma/admin',getParentRoute: () => rootRouteImport
          })
const PlataformaLoginRoute = PlataformaLoginRouteImport.update({
            id: '/plataforma/login',path: '/plataforma/login',getParentRoute: () => rootRouteImport
          })
const PlataformaNoAccessRoute = PlataformaNoAccessRouteImport.update({
            id: '/plataforma/no-access',path: '/plataforma/no-access',getParentRoute: () => rootRouteImport
          })
const AdminContratosIndexRoute = AdminContratosIndexRouteImport.update({
            id: '/contratos/',path: '/contratos/',getParentRoute: () => AdminRoute
          })
const AdminContratosNovoRoute = AdminContratosNovoRouteImport.update({
            id: '/contratos/novo',path: '/contratos/novo',getParentRoute: () => AdminRoute
          })
const AdminDesafiosIndexRoute = AdminDesafiosIndexRouteImport.update({
            id: '/desafios/',path: '/desafios/',getParentRoute: () => AdminRoute
          })
const AdminDesafiosIdRoute = AdminDesafiosIdRouteImport.update({
            id: '/desafios/$id',path: '/desafios/$id',getParentRoute: () => AdminRoute
          })
const AdminFormulariosIndexRoute = AdminFormulariosIndexRouteImport.update({
            id: '/formularios/',path: '/formularios/',getParentRoute: () => AdminRoute
          })
const AdminFormulariosTipoRoute = AdminFormulariosTipoRouteImport.update({
            id: '/formularios/$tipo',path: '/formularios/$tipo',getParentRoute: () => AdminRoute
          })
const AdminPacientesIndexRoute = AdminPacientesIndexRouteImport.update({
            id: '/pacientes/',path: '/pacientes/',getParentRoute: () => AdminRoute
          })
const AdminPacientesIdRoute = AdminPacientesIdRouteImport.update({
            id: '/pacientes/$id',path: '/pacientes/$id',getParentRoute: () => AdminRoute
          })
const AppFormularioIdRoute = AppFormularioIdRouteImport.update({
            id: '/formulario/$id',path: '/formulario/$id',getParentRoute: () => AppRoute
          })
const AppPerfilIndexRoute = AppPerfilIndexRouteImport.update({
            id: '/perfil/',path: '/perfil/',getParentRoute: () => AppRoute
          })
const AppPerfilPagamentosRoute = AppPerfilPagamentosRouteImport.update({
            id: '/perfil/pagamentos',path: '/perfil/pagamentos',getParentRoute: () => AppRoute
          })
const AdminContratosIdIndexRoute = AdminContratosIdIndexRouteImport.update({
            id: '/contratos/$id/',path: '/contratos/$id/',getParentRoute: () => AdminRoute
          })
const AdminContratosIdEditarRoute = AdminContratosIdEditarRouteImport.update({
            id: '/contratos/$id/editar',path: '/contratos/$id/editar',getParentRoute: () => AdminRoute
          })
const AdminFormulariosTipoIndexRoute = AdminFormulariosTipoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminFormulariosTipoRoute
          })
const AdminFormulariosTipoRespostaIdRoute = AdminFormulariosTipoRespostaIdRouteImport.update({
            id: '/$respostaId',path: '/$respostaId',getParentRoute: () => AdminFormulariosTipoRoute
          })
const AdminPacientesIdAppRoute = AdminPacientesIdAppRouteImport.update({
            id: '/pacientes/$id_/app',path: '/pacientes/$id/app',getParentRoute: () => AdminRoute
          })





const AdminFormulariosTipoRouteChildren = {
  AdminFormulariosTipoRespostaIdRoute: AdminFormulariosTipoRespostaIdRoute,AdminFormulariosTipoIndexRoute: AdminFormulariosTipoIndexRoute
}

const AdminFormulariosTipoRouteWithChildren = AdminFormulariosTipoRoute._addFileChildren(AdminFormulariosTipoRouteChildren)



const AdminRouteChildren = {
  AdminAutorizarRoute: AdminAutorizarRoute,AdminAvisosRoute: AdminAvisosRoute,AdminFinanceiroRoute: AdminFinanceiroRoute,AdminFunilRoute: AdminFunilRoute,AdminMaisRoute: AdminMaisRoute,AdminPlataformaRoute: AdminPlataformaRoute,AdminIndexRoute: AdminIndexRoute,AdminContratosNovoRoute: AdminContratosNovoRoute,AdminDesafiosIdRoute: AdminDesafiosIdRoute,AdminFormulariosTipoRoute: AdminFormulariosTipoRouteWithChildren,AdminPacientesIdRoute: AdminPacientesIdRoute,AdminContratosIndexRoute: AdminContratosIndexRoute,AdminDesafiosIndexRoute: AdminDesafiosIndexRoute,AdminFormulariosIndexRoute: AdminFormulariosIndexRoute,AdminPacientesIndexRoute: AdminPacientesIndexRoute,AdminContratosIdEditarRoute: AdminContratosIdEditarRoute,AdminPacientesIdAppRoute: AdminPacientesIdAppRoute,AdminContratosIdIndexRoute: AdminContratosIdIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AppRouteChildren = {
  AppAvisosRoute: AppAvisosRoute,AppDesafiosRoute: AppDesafiosRoute,AppEvolucaoRoute: AppEvolucaoRoute,AppInstalarRoute: AppInstalarRoute,AppMateriaisRoute: AppMateriaisRoute,AppPlanoRoute: AppPlanoRoute,AppIndexRoute: AppIndexRoute,AppFormularioIdRoute: AppFormularioIdRoute,AppPerfilPagamentosRoute: AppPerfilPagamentosRoute,AppPerfilIndexRoute: AppPerfilIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AcompanhamentoNutricionalAustraliaRoute: AcompanhamentoNutricionalAustraliaRoute,AdminRoute: AdminRouteWithChildren,AlimentacaoSaudavelHospitalityAustraliaRoute: AlimentacaoSaudavelHospitalityAustraliaRoute,AnamneseRoute: AnamneseRoute,AnamneseRetornoRoute: AnamneseRetornoRoute,AppRoute: AppRouteWithChildren,ComoEmagrecerMorandoNaAustraliaRoute: ComoEmagrecerMorandoNaAustraliaRoute,ConsultaInicialGratuitaRoute: ConsultaInicialGratuitaRoute,ConsultaNutricionalOnlineAustraliaRoute: ConsultaNutricionalOnlineAustraliaRoute,ConsultoriaRoute: ConsultoriaRoute,ContatoRoute: ContatoRoute,DietaEstudantesBrasileirosAustraliaRoute: DietaEstudantesBrasileirosAustraliaRoute,FormsRoute: FormsRoute,GuiaAlimentacaoBrasileirosAustraliaRoute: GuiaAlimentacaoBrasileirosAustraliaRoute,KitVidaSaudavelRoute: KitVidaSaudavelRoute,LinksRoute: LinksRoute,MercadoAustralianoOQueComprarRoute: MercadoAustralianoOQueComprarRoute,NutricionistaBrasileiraBrisbaneRoute: NutricionistaBrasileiraBrisbaneRoute,NutricionistaBrasileiraMelbourneRoute: NutricionistaBrasileiraMelbourneRoute,NutricionistaBrasileiraNaAustraliaRoute: NutricionistaBrasileiraNaAustraliaRoute,NutricionistaBrasileiraSydneyRoute: NutricionistaBrasileiraSydneyRoute,ObrigadoRoute: ObrigadoRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,PortugueseSpeakingNutritionistBrisbaneRoute: PortugueseSpeakingNutritionistBrisbaneRoute,PromoDiaDasMulheresRoute: PromoDiaDasMulheresRoute,QuestionarioRoute: QuestionarioRoute,QuizRoute: QuizRoute,RaioXRoute: RaioXRoute,SobreRoute: SobreRoute,TermosRoute: TermosRoute,VagaRoute: VagaRoute,BlogSlugRoute: BlogSlugRoute,ClubeBemVindaRoute: ClubeBemVindaRoute,DiagnosticoResultadoRoute: DiagnosticoResultadoRoute,PlataformaAdminRoute: PlataformaAdminRoute,PlataformaLoginRoute: PlataformaLoginRoute,PlataformaNoAccessRoute: PlataformaNoAccessRoute,BlogIndexRoute: BlogIndexRoute,ClubeIndexRoute: ClubeIndexRoute,DiagnosticoIndexRoute: DiagnosticoIndexRoute,PlataformaIndexRoute: PlataformaIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)